import { getClientCookie } from "@lib/cookies.client";

const getRetailTokenClient = async () => {
  const tokensString = await getClientCookie("ackodrive_tokens");
  const tokens = tokensString ? JSON.parse(tokensString) : null;

  return tokens?.access || "";
};

export default getRetailTokenClient;
